import { createPortal } from "react-dom";
import { Btn } from "../ui";

// Fragt beim Login, ob eine Einführungstour gewünscht ist. Antwort wird gemerkt,
// damit die Frage nicht bei jedem Login erneut erscheint.
export function TourWelcomePrompt({ onAccept, onDecline }: { onAccept: () => void; onDecline: () => void }) {
  return createPortal(
    <div className="fixed inset-0 z-[75] flex items-center justify-center bg-slate-900/60 p-4">
      <div className="w-full max-w-md rounded-[16px] border border-[var(--line)] bg-white p-6 shadow-[0_24px_60px_rgba(16,32,38,.28)]">
        <div className="text-lg font-extrabold tracking-[-.02em] text-[var(--ink)]">Willkommen bei Sonne QM 👋</div>
        <div className="mt-2 text-sm leading-relaxed text-[var(--ink-mid)]">
          Möchtest du eine kurze Einführungstour? Wir zeigen dir in jedem Bereich die wichtigsten
          Funktionen – Schritt für Schritt. Du kannst sie jederzeit oben über „Tour“ erneut starten.
        </div>
        <div className="mt-5 flex flex-wrap items-center justify-end gap-2">
          <Btn variant="secondary" onClick={onDecline}>Nein, danke</Btn>
          <Btn onClick={onAccept}>Ja, Tour starten</Btn>
        </div>
      </div>
    </div>,
    document.body
  );
}
